import React from 'react';
import './Info.scss';
import { Str, useTranslate } from 'i18n';
import ReactMarkdown from 'react-markdown';

const Info: React.FunctionComponent = (): JSX.Element => {
  const { t } = useTranslate();
  return (
    <>
      <div className="info">
        <div className="info__padding">
          <h3>
            <Str id={'info_title'} />
          </h3>
          <span className="info__content">
            <ReactMarkdown>{t('info_content')}</ReactMarkdown>
          </span>
        </div>
      </div>
    </>
  );
};

export default Info;
